import React, { Component, Fragment } from 'react';
import api from '../../services/api';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import 'moment-timezone';

// Set the timezone for every instance.
// Use local timezone instead of forcing UTC
// Moment.globalTimezone = 'UTC';

/*
 * HOMEBOX NOTIFICATION FILTERING
 *
 * This component works with the backend notification controller to display filtered notifications.
 * The backend handles business rules filtering based on company status requirements:
 *
 * - Document Analysis Notifications: Only shown if company has CompanyStatusId != 5 ('Habilitado') and != 6 ('Desativado')
 *   When CompanyStatusId = 5 or 6, the notification process is considered complete/closed
 * - Cadastral Notifications: Ready for future business rules implementation
 * - Monthly Notifications: Ready for future business rules implementation
 *
 * The component categorizes notifications into three types for display purposes:
 * 1. cadastralNotifications (documentType includes 'credenciamento')
 * 2. documentAnalysisNotifications (documentType = 'Análise de Documentos')
 * 3. monthlyNotifications (all other notifications)
 */

class HomeBox extends Component {

    state = {
        load: false,
        notifications: [],
        cadastralNotifications: [],
        documentAnalysisNotifications: [],
        monthlyNotifications: [],
        cadastralOpenCount: 0,
        cadastralClosedCount: 0,
        documentAnalysisOpenCount: 0,
        documentAnalysisClosedCount: 0,
        monthlyOpenCount: 0,
        monthlyClosedCount: 0,
        showCadastralClosed: false,
        showDocumentAnalysisClosed: false,
        showMonthlyClosed: false
    }

    async componentDidMount() {
        await this.loadNotifications();
    }

    loadNotifications = async () => {
        this.setState({ load: true });
        try {
            const response = await api.get(`/notifications?UserId=${localStorage.getItem('userId')}&order_by=createdAt&order_direction=DESC&all=true`);
            const notifications = response.data.rows;
            
            // Split notifications into different types
            // The backend now handles the business rules filtering, but we still need to categorize them
            const cadastralNotifications = notifications.filter(notif => 
                notif.documentType && notif.documentType.toLowerCase().includes('credenciamento')
            );
            
            const documentAnalysisNotifications = notifications.filter(notif => 
                notif.documentType === 'Análise de Documentos'
            );

            
            const monthlyNotifications = notifications.filter(notif => 
                !notif.documentType || 
                (!notif.documentType.toLowerCase().includes('credenciamento') && 
                 notif.documentType !== 'Análise de Documentos')
            );
            
            // Count open and closed for each type
            const cadastralOpenCount = cadastralNotifications.filter(notif => notif.visualized === false).length;
            const cadastralClosedCount = cadastralNotifications.filter(notif => notif.visualized === true).length;
            const documentAnalysisOpenCount = documentAnalysisNotifications.filter(notif => notif.visualized === false).length;
            const documentAnalysisClosedCount = documentAnalysisNotifications.filter(notif => notif.visualized === true).length;
            const monthlyOpenCount = monthlyNotifications.filter(notif => notif.visualized === false).length;
            const monthlyClosedCount = monthlyNotifications.filter(notif => notif.visualized === true).length;
            
            this.setState({ 
                notifications,
                cadastralNotifications,
                documentAnalysisNotifications,
                monthlyNotifications,
                cadastralOpenCount,
                cadastralClosedCount,
                documentAnalysisOpenCount,
                documentAnalysisClosedCount,
                monthlyOpenCount,
                monthlyClosedCount,
                load: false
            });
        } catch (error) {
            console.error("Error loading notifications:", error);
            this.setState({ load: false });
        }
    }

    // Function to close a notification
    closeNotification = async (notification) => {
        try {
            const response = await api.patch(`/notifications/${notification.id}`);
            if (response.data.updated) {
                // Refresh notifications after successful update
                await this.loadNotifications();
            } else {
                // Show error message if update failed
                alert(response.data.msg || 'Erro ao fechar notificação');
            }
        } catch (error) {
            console.error("Error closing notification:", error);
            const errorMessage = error.response && error.response.data ? error.response.data.msg : 'Erro ao fechar notificação';
            alert(errorMessage);
        }
    }

    // Function to determine the appropriate hyperlink based on notification type
    getNotificationLink = (notification) => {
        // Define your routing logic based on notification properties
        if (!notification) return '#';

        // Example logic - replace with your application's actual routing rules:
        if (notification.documentType) {
            const documentType = notification.documentType.toLowerCase();
            
            if (documentType.includes('credenciamento')) {
                return `/solicitations?order_by=id&order_direction=DESC&page=1&cnpj=${notification.businessUnity.split(' ')[0] || ''}`;
            } else if (documentType.includes('mensal') || documentType.includes('monthly')) {
                return `/mensal/${notification.id}`;
            } else if (documentType.includes('documento') || documentType.includes('document') || documentType.includes('análise')) {
                return `/companies/${notification.businessUnity.split(' ')[0] || ''}`;
            }
        }
        
        // Default case - if we can't determine a specific route
        return `/notifications/${notification.id}`;
    }

    renderNotificationItem = (item) => {
        const link = this.getNotificationLink(item);
        return (
            <div key={item.id} className="notification-item p-2 mb-2">
                <div className="d-flex align-items-center justify-content-between">
                    <h5 className="mb-1">
                        <Moment format="DD/MM/YYYY HH:mm">{item.createdAt}</Moment>
                    </h5>
                    <div>
                        {/* {!item.visualized && (
                            <button 
                                className="btn btn-sm btn-outline-primary mr-2"
                                onClick={() => this.closeNotification(item)}
                            >
                                Fechar
                            </button>
                        )} */}
                        <span className={`badge ${item.visualized ? 'badge-info' : 'badge-success'}`}>
                            {item.visualized ? 'Fechado' : 'Aberto'}
                        </span>
                    </div>
                </div>
                <Link to={link} className="text-primary notification-message">
                    {item.message}
                </Link>
                <div className="notification-details mt-1">
                    {item.companyName && <small><strong>Empresa:</strong> {item.companyName}</small>}
                    {item.documentType && <small className="ml-2"><strong>Tipo:</strong> {item.documentType}</small>}
                </div>
                <hr/>
            </div>
        );
    }

    renderCounters = (openCount, closedCount, showClosed, toggleFunction) => (
        <div className="row mb-3">
            <div className="col-6">
                <div
                    className={`card text-white ${!showClosed ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleFunction(false)}
                >
                    <div className="card-body p-2">
                        <div className="d-flex align-items-center">
                            <div className="stats">
                                <h3 className="text-white mb-0">{openCount}</h3>
                                <h6 className="text-white mb-0">Em Andamento</h6>
                            </div>
                            <div className="stats-icon text-right ml-auto">
                                <i className="fa fa-envelope-open fa-2x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-6">
                <div
                    className={`card text-white ${showClosed ? 'bg-info' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => toggleFunction(true)}
                >
                    <div className="card-body p-2">
                        <div className="d-flex align-items-center">
                            <div className="stats">
                                <h3 className="text-white mb-0">{closedCount}</h3>
                                <h6 className="text-white mb-0">Fechados</h6>
                            </div>
                            <div className="stats-icon text-right ml-auto">
                                <i className="fa fa-envelope fa-2x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    renderNotificationsBox = (title, notifications, openCount, closedCount, showClosed, toggleFunction) => {
        // Filter notifications based on whether we're showing closed or open
        const filteredNotifications = notifications.filter(notif =>
            showClosed ? notif.visualized === true : notif.visualized === false
        );

        return (
            <div className="card h-100">
                <div className="card-body">
                    <h4 className="card-title">{title}</h4>
                    {this.renderCounters(openCount, closedCount, showClosed, toggleFunction)}
                    <div className="notification-list" style={{ minHeight: '200px', position: 'relative' }}>
                        {this.state.load ? (
                            <div className="text-center p-5">
                                <p className="mt-3">Carregando notificações...</p>
                            </div>
                        ) : (
                            filteredNotifications.length > 0 ?
                                filteredNotifications
                                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                    .map(this.renderNotificationItem)
                                :
                                <p>Nenhuma notificação disponível.</p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Caixa de entrada
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner ml-2"></i> : null}
                        </h3>
                    </div>
                </div>

                <div className="row alert alert-primary">
                    <span>
                        Notificações dos seus processos no sistema DP World.
                    </span>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        {this.renderNotificationsBox(
                            "Notificações de Cadastro",
                            this.state.cadastralNotifications,
                            this.state.cadastralOpenCount,
                            this.state.cadastralClosedCount,
                            this.state.showCadastralClosed,
                            (showClosed) => {
                                this.setState({ load: true }, () => {
                                    setTimeout(() => {
                                        this.setState({ showCadastralClosed: showClosed, load: false });
                                    }, 300);
                                });
                            }
                        )}
                    </div>
                    <div className="col-md-6">
                        {this.renderNotificationsBox(
                            "Análise de Documentos",
                            this.state.documentAnalysisNotifications,
                            this.state.documentAnalysisOpenCount,
                            this.state.documentAnalysisClosedCount,
                            this.state.showDocumentAnalysisClosed,
                            (showClosed) => {
                                this.setState({ load: true }, () => {
                                    setTimeout(() => {
                                        this.setState({ showDocumentAnalysisClosed: showClosed, load: false });
                                    }, 300);
                                });
                            }
                        )}
                    </div>
                    {/*
                    <div className="col-md-4">
                        {this.renderNotificationsBox(
                            "Notificações Mensais",
                            this.state.monthlyNotifications,
                            this.state.monthlyOpenCount,
                            this.state.monthlyClosedCount,
                            this.state.showMonthlyClosed,
                            (showClosed) => {
                                this.setState({ load: true }, () => {
                                    setTimeout(() => {
                                        this.setState({ showMonthlyClosed: showClosed, load: false });
                                    }, 300);
                                });
                            }
                        )}
                    </div>
                    */}
                </div>
            </Fragment>
        )
    }
}

export default HomeBox;
